import { ErrorClient } from 'NSwag/ThinClient/Client.nswag';

export const reportError = (error: string, errorInfo: string): Promise<void> => {
    let client = new ErrorClient();

    return client.logError(error, errorInfo);
}